import { propertyService } from '@iso/services';

import permissionActions from '@iso/redux/permission/actions';
import subscriptionActions from '@iso/redux/subscription/actions';
import picActions from '@iso/redux/property_pic/actions';
import trialSatelliteExpiredActions from '@iso/redux/property_trial_satellite/actions';
import { setMeasurementsEnabled } from '@iso/lib/helpers/mapMeasurements';

const { changeActivePermission } = permissionActions;
const { changeActivePropertySubscription } = subscriptionActions;
const { changeActivePropertyPIC } = picActions;
const { changeActiveTrialSatelliteExpired } = trialSatelliteExpiredActions;

const actions = {
  STORE_PROPERTIES: 'STORE_PROPERTIES',
  CHANGE_ACTIVITY: 'CHANGE_ACTIVITY',
  CHANGE_AGENT: 'CHANGE_AGENT',
  SET_WELCOME_DISMISSED: 'SET_WELCOME_DISMISSED',
  SET_SELECTED_PROPERTY_MODAL_DISMISSED: 'SET_SELECTED_PROPERTY_MODAL_DISMISSED',
  SET_RESTORING_PROPERTY: 'SET_RESTORING_PROPERTY',
  
  // `persist` (default true) controls whether the change is written to the
  // backend (users_properties.is_actived) so the active property survives
  // logout and follows the user onto another device. Every user-initiated
  // activation path benefits automatically; the only caller that opts out is
  // the on-load rehydration from localStorage in PrivateLayout, where the
  // value is already persisted and re-writing it on every page load is wasteful.
  changeActiveProperty: (activeProperty, persist = true) => {
    return (dispatch, getState) => {
      // Defensive: ignore calls with no usable property (e.g. an upstream
      // auto-select that resolved to undefined) instead of throwing.
      if (!activeProperty || !activeProperty.id) {
        return;
      }

      const previousActivePropertyId = getState().property.activePropertyId;

      dispatch(changeActive(activeProperty.id));
      dispatch(changeActivePermission(activeProperty.id));
      dispatch(changeActivePropertySubscription(activeProperty.subscription_label));
      dispatch(changeActivePropertyPIC(activeProperty.PIC));
      dispatch(changeActiveTrialSatelliteExpired(activeProperty.trial_satellite_expired));

      // On-path measurements are a property-level choice, so apply it here
      // rather than in any one map: every map in the app — the property map,
      // the shared public map, the small maps inside modals — then follows the
      // property the user is looking at. Off unless the property says 1, so an
      // older cached payload with no such field draws clean rather than
      // labelling every edge of every paddock on it.
      setMeasurementsEnabled(Number(activeProperty.map_show_edge_distance) === 1);

      // Persist against the user so it is restored on the next login. Only
      // write when it actually changes, so effects that re-select the same
      // property don't fire redundant requests. Log failures so a dropped
      // write (expired JWT, network, 5xx) is observable instead of silent.
      if (persist && previousActivePropertyId !== activeProperty.id) {
        propertyService.active(activeProperty.id).catch((err) => {
          console.error('[changeActiveProperty] Failed to persist active property:', err);
        });
      }
    }
  },

  changeAgent: (agent) => {
    return dispatch => {
      dispatch(changeAgent(agent));
    }
  }, 
  setWelcomeDismissed: () => ({
    type: actions.SET_WELCOME_DISMISSED,
  }), 
  setSelectedPropertyModalDismissed: () => ({
    type: actions.SET_SELECTED_PROPERTY_MODAL_DISMISSED,
  }),
  setRestoringProperty: (restoring) => ({
    type: actions.SET_RESTORING_PROPERTY,
    restoring,
  }),
};

function storeProperties(properties) {
  return {
    type: actions.STORE_PROPERTIES,
    properties,
  }
}

function changeActive(activePropertyId){
  return {
    type: actions.CHANGE_ACTIVITY,
    activePropertyId
  }
}

function changeAgent(agent){
  return {
    type: actions.CHANGE_AGENT,
    agent
  }

}
 

export default actions;
